import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const StationClosures = lazy(() => import('./station-closures'));

export function StationClosuresPage() {
  return (
    <article className="space-y-6" data-testid="station-closures-page">
      <Suspense fallback={<Loading />}>
        <StationClosures />
      </Suspense>
    </article>
  );
}
